import { CommonOperationCost } from '../operation-cost'

export const UnitedStatesOperationCost = {
  ...CommonOperationCost,
} as const
